import { useEffect, useLayoutEffect, useRef, useState } from "react";

/**
 *
 * @param initialArray 初始化数据
 * @returns 返回有状态性的值、添加函数、移除指定索引函数、清空数据函数
 */
export const useArray = <T>(initialArray: T[]) => {
  const [list, setList] = useState(initialArray);

  const add = (item: T) => {
    setList([...list, item]);
  };

  const removeIndex = (index: number) => {
    const temp = [...list];
    temp.splice(index, 1);
    setList(temp);
  };
  const clear = () => {
    setList([]);
  };

  return { list, add, removeIndex, clear };
};

export const useDocumentTitle = (title: string) => {
  const oldTitle = document.title;

  useEffect(() => {
    document.title = title;
  }, [title]);

  useEffect(() => {
    return () => {
      document.title = oldTitle;
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
};

export const useImgScale = () => {
  const ref = useRef<HTMLElement>(null);

  const zoomIn = (dom: HTMLElement) => {
    dom.style.backgroundSize = 130 + "%";
  };
  const zoomOut = (dom: HTMLElement) => {
    dom.style.backgroundSize = 100 + "%";
  };

  useEffect(() => {
    const dom = ref.current;
    dom?.addEventListener("mousemove", zoomIn.bind(this, dom));
    dom?.addEventListener("mouseleave", zoomOut.bind(this, dom));

    return () => {
      dom?.removeEventListener("mousemove", zoomIn.bind(this, dom));
      dom?.addEventListener("mouseleave", zoomOut.bind(this, dom));
    };
  }, []);

  return ref;
};

export function useWindowSize() {
  const [size, setSize] = useState([0, 0]);
  useLayoutEffect(() => {
    function updateSize() {
      setSize([window.innerWidth, window.innerHeight]);
    }
    window.addEventListener("resize", updateSize);
    updateSize();
    return () => window.removeEventListener("resize", updateSize);
  }, []);
  return size;
}
